import React from "react";

const TableCell = props => {
  // console.log(typeof props.value);
  return (
    <React.Fragment>
      {props.value === undefined || props.value === null ? (
        <>&mdash;</>
      ) : (
        props.value
      )}
    </React.Fragment>
  );
};

export default TableCell;
